import '@babel/polyfill';
import React from 'react';
import {render} from 'react-dom';
import {connect, Provider} from 'react-redux';
import reduxStore from './ReduxStore';
import {BrowserRouter, withRouter} from 'react-router-dom';
import AppRoutes from './AppRoutes';
import Header from "../header/header";
import webservice from "../common/Webservice";
import "../../css/index.scss";
import userManager from './UserManager';
import currentUrl from './CurrentUrl';
import {OidcProvider} from "redux-oidc";
import {AriaLiveContextProvider} from "@utahdts/dts-react-common";

class AppClass extends React.Component {
	constructor(props) {
		super(props);
		currentUrl.storeUrl();
		this.state = {
			isAjaxing: true
		};
	}

	componentWillMount() {
		webservice.public.navigation.fiscalYears()
			.then(() => this.setState({isAjaxing: false}))
			.catch((error) => {
				this.setState({isAjaxing: false});
			});
	}

	componentDidUpdate() {
		currentUrl.storeUrl();
	}

	render() {
		return (
			<React.Fragment>
				<Header history={this.props.history}/>
				<main>
					<section className="section-content flex1">
						{!this.state.isAjaxing && <AppRoutes history={this.props.history}/>}
					</section>
				</main>
			</React.Fragment>
		);
	}
}

const App = withRouter(connect()(AppClass));

render((
	<BrowserRouter basename={currentUrl.basename}>
		<AriaLiveContextProvider>
			<Provider store={reduxStore}>
				<OidcProvider store={reduxStore} userManager={userManager}>
						<App/>
				</OidcProvider>
			</Provider>
		</AriaLiveContextProvider>
	</BrowserRouter>
), document.getElementById('react'));


